import { getNestedProperty } from '@opallabs/lambda'
import { AvatarCollection, State, StateKeys } from '../../../../types'

type GetAvatars = (state: State) => AvatarCollection | undefined

export const getAvatars: GetAvatars = (state) =>
  getNestedProperty<AvatarCollection>(
    state,
    StateKeys.jsonApiEntities,
    StateKeys.avatars
  )
